import React, { useEffect, useMemo, useState } from 'react';
import InputLayout from '../Form/InputLayout';
import { Dropdown } from 'primereact/dropdown';
import { capitalizeCamelCase } from '../../utils/commonFunctions';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

const CustomMultiSelectEditable = ({
    options,
    editableFields = [],
    showFields = [],
    onChange,

    // ........
    label,
    name,
    data,
    value,
    errorMessage,
    extraClassName,
    required,
    col = 12,
    inputClass,
    disabled = false,
    ...props
}) => {
    const _value = value || data?.[name];
    const [selectedItems, setSelectedItems] = useState([]);
    useEffect(() => {
        if (_value) {
            if (JSON.stringify(_value) !== JSON.stringify(selectedItems)) {
                setSelectedItems(_value);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_value]);

    const handleSelect = (e) => {
        const selectedValue = e.value;
        if (!selectedValue) return;

        const isAlreadySelected = selectedItems.some((item) => item.value === selectedValue);
        if (isAlreadySelected) return;
        let newItem = options.find((item) => item.value === selectedValue);
        const updated = [...selectedItems, newItem];
        setSelectedItems(updated);
        onChange && onChange({ name, value: updated });
    };

    const updateField = (id, field, value) => {
        const index = selectedItems.findIndex((item) => item.value === id);
        if (index === -1) return;

        const updated = [...selectedItems];
        updated[index] = { ...updated[index], [field]: value };
        setSelectedItems(updated);
        onChange && onChange({ name, value: updated });
    };

    const removeItem = (value) => {
        const updated = selectedItems.filter((item) => item.value !== value);
        setSelectedItems(updated);
        onChange && onChange({ name, value: updated });
    };

    const getFullData = (val) => options.find((opt) => opt.value === val);

    const filterOptions = useMemo(() => {
        return options.filter((opt) => !selectedItems.some((item) => item?.value === opt?.value));
    }, [options, selectedItems]);

    const actionTemplate = (item) => {
        return (
            <span className="flex">
                <i className="mx-2 cursor-pointer pi pi-trash" onClick={() => removeItem(item.value)} />
            </span>
        );
    };

    const nameTemplate = (item) => {
        const fullData = getFullData(item?.value);
        return fullData?.name || item?.value;
    };

    const editableTemplate = (item, field) => {
        return <InputText value={item?.[field]} onChange={(e) => updateField(item?.value, field, e.target.value)} />;
    };

    return (
        <>
            <InputLayout col={4} label={label} name={name} required={required} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
                <Dropdown
                    id={name}
                    name={name}
                    value={value || data?.[name]}
                    className={`w-full ${inputClass ? inputClass : ''} ${errorMessage ? 'p-invalid' : ''}`}
                    disabled={disabled}
                    optionLabel="name"
                    onChange={handleSelect}
                    options={filterOptions}
                    {...props}
                />
            </InputLayout>
            {selectedItems?.length > 0 && (
                <InputLayout col={12} label={`Selected ${name}`} required={required} extraClassName={extraClassName} data={data} errorMessage={errorMessage}>
                    <DataTable value={selectedItems} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="name" header="Name" body={nameTemplate}></Column>
                        {showFields.map((field) => (
                            <Column key={field} header={capitalizeCamelCase(field)} field={field}></Column>
                        ))}

                        {editableFields.map((field) => (
                            <Column
                                key={field}
                                header={capitalizeCamelCase(field)}
                                field={field}
                                body={(item) => editableTemplate(item, field)}
                                style={{ width: '10%' }}
                            ></Column>
                        ))}
                        <Column header="Action" body={actionTemplate} style={{ width: '100px' }}></Column>
                    </DataTable>
                </InputLayout>
            )}
        </>
    );
};

export default CustomMultiSelectEditable;
